import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';
import { Router } from '@angular/router';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class LedgerComponent implements OnInit {
  isVisible = false;
  items;
  filteredItems;
  isLoading = true;
  Errors = null;
  data = [];
  price = [];
  opdPrice: any = [];
  total = 0.0;
  net = 0.0;
  discount = 2;
  total_discount: any = 0;
  discount_amout = 0.0;
  amount_owing: number = 0.0;
  amount_paid: number = 0.0;
  total_Paid: number = 0.0;
  private _searchText: string;
  encounters: any = [];
  name;
  id;
  refDr;
  payType;
  is_verified;
  success;
  buildLoad: boolean = false;
  visible = false;
  startdate = '';
  enddate = '';
  dept_code = 0;
  sub_dept_code = 0;
  investigation = '';
  patientNmae = '';
  gender = '';
  phone = '';
  depts: any = [];
  subDepts: any = [];
  investigatonList: any = [];
  acountStat: any = [];

  stateForm = new FormGroup({
    bill_id: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
  });

  get formControls(): any {
    return this.stateForm['controls'];
  }

  constructor(
    public router: Router,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    let date = new Date();
    let currentDate = moment(date).format('YYYY-MM-DD');
    this.getStat();

    this.bill
      .searchEncounters(
        currentDate,
        currentDate,
        this.dept_code,
        this.sub_dept_code,
        this.investigation,
        this.patientNmae,
        this.gender,
        this.phone,
        this.is_verified,
        -1,
        -1,
        -1,
        -1
      )
      .subscribe(
        (resSuccess) => {
          this.encounters = resSuccess.data;
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

    this.bill.getPatTypes().subscribe(
      (resSuccess) => {
        this.payType = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getStat() {
    this.bill.getAcountStat().subscribe(
      (resSuccess) => {
        this.acountStat = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  reload() {
    this.bill.getEncounters().subscribe(
      (resSuccess) => {
        this.encounters = resSuccess.map((item) => ({
          selected: false,
          Bill_ID: item.Bill_ID,
          Bill_No: item.Bill_No,
          Recd_Payment: item.Recd_Payment,
          amountOutstanding: item.amountOutstanding,
          amountPaid: item.amountPaid,
          billDate: item.billDate,
          branchCode: item.branchCode,
          concession_code: item.concession_code,
          discount: item.discount,
          id: item.id,
          narration: item.narration,
          netAmount: item.netAmount,
          patientName: item.patientName,
          patient_type: item.patient_type,
          ref_hosp_code: item.ref_hosp_code,
          referred_doctor: item.referred_doctor,
          registration_no: item.registration_no,
          totalAmount: item.totalAmount,
        }));
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  formatData() {
    this.discount_amout = this.total - this.total_Paid;
  }

  onChangeTotla() {
    this.formatData();
  }

  setItem(item) {
    let i;
    for (i = 0; i < this.encounters.length; i++) {
      this.encounters[i].selected = false;
    }

    this.total_Paid = item.amountPaid;
    this.total = item.totalAmount;
    this.net = item.netAmount;
    this.amount_owing = item.amountOutstanding;
    this.name = item.patientName;
    this.refDr = item.referred_doctor;
    this.id = item.Bill_ID;
    this.discount_amout = item.discount;

    let index = this.encounters.indexOf(item);
    if (item.selected == false) {
      item.selected = true;
      this.encounters[index] = item;
    } else {
      item.selected = false;
      this.encounters[index] = item;
    }

    this.stateForm.patchValue({
      bill_id: item.Bill_ID,
    });
    console.log(this.id);
  }
  updateForm() {
    this.stateForm.patchValue({
      id: this.id,
    });
  }

  searchEcounters() {
    this.isLoading = true;
    this.bill
      .searchEncounters(
        this.startdate,
        this.enddate,
        this.dept_code,
        this.sub_dept_code,
        this.investigation,
        this.patientNmae,
        this.gender,
        this.phone,
        this.is_verified,
        -1,
        -1,
        -1,
        -1
      )
      .subscribe(
        (resSuccess) => {
          this.visible = !this.visible;
          this.encounters = resSuccess.data.map((item) => ({
            selected: false,
            Bill_ID: item.Bill_ID,
            Bill_No: item.Bill_No,
            Recd_Payment: item.Recd_Payment,
            amountOutstanding: item.amountOutstanding,
            amountPaid: item.amountPaid,
            billDate: item.billDate,
            branchCode: item.branchCode,
            concession_code: item.concession_code,
            discount: item.discount,
            id: item.id,
            narration: item.narration,
            netAmount: item.netAmount,
            patientName: item.patientName,
            patient_type: item.patient_type,
            ref_hosp_code: item.ref_hosp_code,
            referred_doctor: item.referred_doctor,
            registration_no: item.registration_no,
            totalAmount: item.totalAmount,
          }));
          this.isLoading = false;
          console.log(resSuccess);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
  }

  makeVisible() {
    this.visible = !this.visible;
  }
  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.startdate, this.dept_code);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.enddate);
  }

  onSubmit(e) {
    this.buildLoad = true;
    e.preventDefault();
    this.updateForm();
    this.Errors = null;
    console.log(this.stateForm.value);
    const { bill_id, status } = this.stateForm.value;
    console.log(this.stateForm.value);
    this.bill.updateBill(bill_id, status).subscribe(
      (resSuccess) => {
        this.success = resSuccess;
        this.buildLoad = false;
        console.log(resSuccess);

        if (this.success.success) {
          // this.closeModal()
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          this.router.navigateByUrl('/print-receipt');
          this.getStat();
        } else {
          this.Errors = 'Not successful, please try again';
          this._snackBar.open('Not successful, please try again', '', {
            duration: 4000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.buildLoad = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }
}
